import useHttp from './use-http';
import { ref } from 'vue-demi';

const useLocations = () => {
    const { http } = useHttp();

    const countries = ref([]);
    const states = ref([]);
    const cities = ref([]);

    /**
     * Get the list of countries
     */
    const getCountries = (countryCodeList = null, labelField = 'name', valueField = 'code') => {
        http.get('/location/countries').then((res) => {
            countries.value = res.data.data;
            if (countryCodeList) {
                countries.value = countries.filter((obj) => countryCodeList.includes(obj[valueField]));
            }
            // Allow for use as `select` (and `g-select`) options
            countries.value.forEach((country) => {
                country.label = country[labelField];
                country.value = country[valueField];
            });
        });
    };

    /**
     * Get the list of states by country
     *
     * @param {string} country_id
     */
    const getStates = (countryId) => {
        http.get(`/location/countries/${countryId}/states`).then((res) => {
            states.value = res.data.data;
        });
    };

    /**
     * Get the list of cities by state
     *
     * @param {string} state_id
     */
    const getCities = (stateId) => {
        http.get(`/location/states/${stateId}/cities`).then((res) => {
            cities.value = res.data.data;
        });
    };

    /**
     * Get the country by name
     *
     * @param  {string} type
     * @param  {string} name
     * @return {Promise}
     */
    const getLocationByName = (type, name) => {
        return http.post(`/location/name/${type}`, { name });
    };

    return {
        countries,
        states,
        cities,
        getCountries,
        getStates,
        getCities,
        getLocationByName
    };
};

export default useLocations;
